module.exports = __webpack_public_path__ + "assets/img/onclick.b3e5fcd4.webp";